import React, { useEffect, useState, forwardRef } from "react";
import OrderItem from "./OrderItem";
import styles from "./orderListPanel.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

const OrderListPanel = forwardRef((props, ref) => {
  const orderList = props.orderList || [];
  const [checkedIndex, setCheckedIndex] = useState(null);

  const { i18n } = useTranslation();

  useEffect(() => {
    setCheckedIndex(null);
  }, [orderList]);

  const checkStateHandler = (index) => {
    if (checkedIndex === index) {
      setCheckedIndex(null);
      props.offerHandler(null);
    } else {
      setCheckedIndex(index);
      props.offerHandler(orderList[index]);
    }
  };

  const calculateIsDisabled = (order, isFirstLeg) => {
    const orderDepartureTime = new Date(order.departureTime).getTime();
    const orderArrivalTime = new Date(order.arrivalTime).getTime();
    const bufferTime = 0;

    if (!isFirstLeg && props.selectedDepartureEndTime) {
      const minimumDepartureTime = props.selectedDepartureEndTime + bufferTime;
      return orderDepartureTime < minimumDepartureTime;
    }

    if (isFirstLeg && props.selectedReturnStartTime) {
      const maximumDepartureTime = props.selectedReturnStartTime - bufferTime;
      return orderArrivalTime > maximumDepartureTime;
    }

    return false;
  };

  const formatLocalizedDate = (isoDate, lang) => {
    const dt = DateTime.fromISO(isoDate, { zone: "Europe/Warsaw" });
    return lang === "en"
      ? dt.toFormat("MM/dd/yyyy")
      : dt.toFormat("dd.MM.yyyy");
  };

  return (
    <div ref={ref}>
      <Container fluid>
        <Row>
          <Col className="col-6 gx-2 mb-2">
            <h4 style={{ textAlign: "left" }}>{props.direction}</h4>
          </Col>
          <Col className="col-6 gx-2 mb-2">
            <h4 style={{ textAlign: "right", color: "grey" }}>
            {formatLocalizedDate(props.date, i18n.language)}
            </h4>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="col-12 gx-2 mb-2 text-center">
            <ul className={styles.list}>
              {orderList.map((order, index) => {
                const isDisabled = calculateIsDisabled(order, props.isFirstLeg);
                return (
                  <li key={index}>
                    <OrderItem
                      departureTime={order.departureTime}
                      arrivalTime={order.arrivalTime}
                      index={index}
                      price={order.price.amount}
                      currency={order.price.currency}
                      checked={checkedIndex === index}
                      checkHandler={checkStateHandler}
                      disabled={isDisabled}
                    />
                  </li>
                );
              })}
            </ul>
          </Col>
        </Row>
      </Container>
    </div>
  );
});

export default OrderListPanel;
